import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { PasswordField } from 'seagull';
import { useStoreActions } from "../../../contexts";
import { routes } from "../../../constants";
import { handlePromise, sendErrReport } from "../../../infra/utils";
import UnauthorizedPageContainer from "../components/UnauthorizedPageContainer";
import { FormContainer, FormTitle, FormFields, VerticalFormFields, SubmitButtonField, ErrorMessage } from "../components/FormComponents";
export function SetPasswordScreen() {
  const history = useHistory();
  const {
    logBI,
    api
  } = useStoreActions();
  const [passwordSetInProgress, setPasswordSetInProgress] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const {
    handleSubmit,
    control,
    formState,
    getValues,
    watch
  } = useForm({
    mode: 'onChange'
  });
  useEffect(() => {
    document.title = 'Anchor Reset Password';
  }, []);
  const onSubmit = handleSubmit(async (data, e) => {
    logBI(10601);
    e === null || e === void 0 || e.preventDefault();
    setPasswordSetInProgress(true);
    const {
      password
    } = data;
    const result = await handlePromise(api.auth.setPassword(password));
    if (!result.success) {
      sendErrReport(result.error);
      setPasswordSetInProgress(false);
      setErrorMessage('An error occurred');
      const subscription = watch(() => {
        setErrorMessage('');
        subscription.unsubscribe();
      });
    } else {
      setPasswordSetInProgress(false);
      history.push(routes.home);
    }
  });
  return /*#__PURE__*/React.createElement(UnauthorizedPageContainer, null, /*#__PURE__*/React.createElement(FormContainer, {
    onSubmit: onSubmit,
    "data-testid": "set-password-form"
  }, /*#__PURE__*/React.createElement(FormTitle, null, "Create new password"), /*#__PURE__*/React.createElement(FormFields, null, /*#__PURE__*/React.createElement(VerticalFormFields, null, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "password",
    defaultValue: "",
    rules: {
      required: true,
      minLength: {
        value: 10,
        message: 'Use 10 or more characters'
      },
      deps: 'confirm-password'
    },
    render: _ref => {
      var _fieldState$error;
      let {
        field: {
          onChange,
          onBlur: _onBlur,
          value
        },
        fieldState
      } = _ref;
      return /*#__PURE__*/React.createElement(PasswordField, {
        value: value,
        onChange: onChange,
        onBlur: () => {
          logBI(10203, {
            isPasswordValid: !fieldState.error
          });
          _onBlur();
        },
        error: !!fieldState.error,
        helperText: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
        label: "Password",
        testid: "password-input"
      });
    }
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "confirm-password",
    defaultValue: "",
    rules: {
      required: true,
      validate: value => {
        const doPasswordsMatch = getValues('password') === value;
        return doPasswordsMatch || 'Passwords do not match';
      }
    },
    render: _ref2 => {
      var _fieldState$error2;
      let {
        field: {
          onChange,
          onBlur,
          value
        },
        fieldState,
        formState
      } = _ref2;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PasswordField, {
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        error: !formState.isValid && !!fieldState.error,
        helperText: !formState.isValid && ((_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message),
        label: "Confirm password",
        testid: "confirm-password-input"
      }));
    }
  }))), /*#__PURE__*/React.createElement(SubmitButtonField, {
    disabled: !formState.isValid,
    "data-testid": "set-password-button",
    isLoading: passwordSetInProgress
  }, "Set Password"), errorMessage && /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "error-msg"
  }, errorMessage)));
}